import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import resolveByTheme from './resolveByTheme';
import themes from '../themes';

type Props = {
  children: ReactNode;
};

/**
 * **Note: To make this function working setup current theme as environment variable `THEME`.**
 *
 * @param {object} props
 * @returns React.Node
 */
const EnvironmentThemeProvider = (props: Props) => (
  <ThemeProvider theme={resolveByTheme(theme => themes[theme], 'currys')}>
    {props.children}
  </ThemeProvider>
);

export default EnvironmentThemeProvider;
